import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { InputComponent } from '../../../shared/input/input.component';
import { NgOtpInputComponent, NgOtpInputModule } from 'ng-otp-input';
import { ForgotpasswordService } from '../../../services/forgot-password/forgotpassword.service';
import { TemplatePasswordComponent } from '../../../shared/template-password/template-password.component';
import * as forgotpasswordconstants from '../../../shared/constants/forgot-password-constant';
import { IconsComponent } from '../../../shared/icons/icons.component';
import { MessageModalService } from '../../../services/message-modal/message-modal.service';
import { ButtonComponent } from '../../../shared/button/button.component';
@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatStepperModule,
    InputComponent,
    MatInputModule,
    IconsComponent,
    NgOtpInputModule,
    TemplatePasswordComponent,
    ButtonComponent,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css',
})
export class ForgotPasswordComponent {
  isLinear = true;
  firstForm!: FormGroup;
  secondForm!: FormGroup;
  thirdForm!: FormGroup;
  combinedForm!: FormGroup;
  mailIcon = forgotpasswordconstants.MAILICON;
  emailInputType = forgotpasswordconstants.EMAILINPUTTYPE;
  emailLabel = forgotpasswordconstants.EMAILLABEL;
  emailPlaceholder = forgotpasswordconstants.EMAILPLACEHOLDER;
  title = forgotpasswordconstants.TITLE;
  desc = forgotpasswordconstants.DESC;
  btnStyleFilledLarge = forgotpasswordconstants.BTNSTYLEFILLEDLARGE;
  btnStyleFilledLargeDisabled = forgotpasswordconstants.BTNSTYLEFILLEDLARGEDISABLED;
  submitDisabled = forgotpasswordconstants.SUBMITDISABLED;
  otpCode: string = forgotpasswordconstants.OTP_CODE;
  buttonsubmit = forgotpasswordconstants.BUTTONSUBMIT;
  btnMatFlat = forgotpasswordconstants.BTNMATFLAT;
  back = forgotpasswordconstants.BACK;

  templatePasswordComponent!: TemplatePasswordComponent;

  otp!: string;
  newPassword!: string;
  ariaHidden = 'false';
  ariaLabel = 'chevron left';
  icon = 'chevron_left';

  emailMat = new FormControl('', [Validators.required, Validators.email]);
  @ViewChild('stepper') stepper!: MatStepper;
  otpError: boolean = false;
  private lastOtp = '';
  @ViewChild(NgOtpInputComponent) otpInput!: NgOtpInputComponent;
  constructor(
    private fb: FormBuilder,
    private forgotPasswordService: ForgotpasswordService,
    private router: Router,
    private messageModalService: MessageModalService
  ) {}
  ngOnInit() {
    this.emailMat = new FormControl('', [Validators.required, Validators.email]);
    this.templatePasswordComponent = new TemplatePasswordComponent(this.fb);
    this.firstForm = this.fb.group({
      emailMat: this.emailMat,
    });
    this.secondForm = this.fb.group({
      otp: ['', Validators.required],
    });
    this.thirdForm = this.fb.group({
      confirmPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
    });
  }

  handleChange() {}
  handleGotoLogin() {
    this.router.navigate(['/login']);
  }
  fetchOtp() {
    if (this.emailMat.value) {
      this.forgotPasswordService.fetchOtp(this.emailMat.value).subscribe({
        next: (response) => {
          if (response.success) {
            this.otpCode = response.code;
            this.messageModalService.openModal($localize`Success`, $localize`${response.message}`);
          }
        },
        error: (err) => {
          console.error(err);
        },
      });
    }
  }
  onOtpChange(event: string) {
    if (event.length !== 6) {
      // Partial code: clear the guard so re-entering the same digits validates again.
      this.lastOtp = '';
      this.submitDisabled = true;
      this.otpError = false;
      return;
    }
    if (!this.emailMat.value) {
      return;
    }
    // Guard against re-validating a code we have already sent. ng-otp-input re-emits the full
    // value on any keyup over a filled box (Enter, Tab, the key release after a paste), and the
    // code is single-use, so the duplicate request comes back 400 and fails against a code the
    // backend has already accepted.
    if (this.lastOtp === event) {
      return;
    }
    this.lastOtp = event;
    this.forgotPasswordService.validateOtp(this.emailMat.value, event).subscribe({
      next: (response) => {
        if (response.success) {
          // Accepting the code is what authorises change-password server-side, so there is
          // nothing left for the user to confirm - advance without waiting for a Continue click.
          this.submitDisabled = false;
          this.otpError = false;
          this.stepper.next();
        } else {
          this.submitDisabled = true;
          this.otpError = true;
        }
      },
      error: (err) => {
        console.error(err);
        this.submitDisabled = true;
        this.otpError = true;
      },
    });
  }

  resendOtp() {
    this.otpInput.setValue('');
    this.otpError = false;
    this.lastOtp = '';
    this.fetchOtp();
  }
  emittedPassword(event: string) {
    this.thirdForm.patchValue({ newPassword: event });
  }
  submitThirdForm() {
    const email = this.firstForm.get('emailMat')?.value;
    const new_password = this.thirdForm.get('newPassword')?.value;
    this.forgotPasswordService.changePassword(email, new_password).subscribe({
      next: (response) => {
        this.router.navigate(['/login']);
      },
      error: (err) => {
        console.error(err);
      },
    });
  }
  onFirstSubmit() {
    if (this.firstForm.valid) {
      this.fetchOtp();
      this.stepper.next();
    }
  }
}
